const initial = {
    membershipData: {},
    error: null,
    loading: false
  };
  
  function membershipReducer(state = initial, action) {
    switch (action.type) {
      case 'FETCH_MEMBERSHIP_DATA':
        return {
          ...state,
          membershipData: {},
          loading: true
        };
      case 'FETCH_MEMBERSHIP_DATA_SUCCESS':
        return {
            ...state,
            membershipData: {...action.membershipData},
            loading: false
          };
      case 'FETCH_MEMBERSHIP_DATA_FAIL':
        return {
          ...state,
          loading: false,
          error: action.error
        };
      default:
        return state;
    }
  }
  
  export default membershipReducer;
  